import { API_URL_FAQ } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getFaqs = () =>
  apiInstance({
    url: API_URL_FAQ,
    params: {
      limit: 1000,
      sort: "order",
      order: 1,
    },
  });

export default getFaqs;
